module.exports = __webpack_public_path__ + "img/B550.1542ca26.jpg";